import { render, staticRenderFns } from "./AppLayout.vue?vue&type=template&id=635632a4&"
import script from "./AppLayout.vue?vue&type=script&lang=js&"
export * from "./AppLayout.vue?vue&type=script&lang=js&"
import style0 from "./AppLayout.vue?vue&type=style&index=0&id=635632a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports